import {
  ASSESSEMENT_ADD_NEW,
  ASSESSEMENT_ADD_NEW_SUCCESS,
  ASSESSEMENT_ADD_NEW_ERROR,
  ASSESSEMENT_DELETE,
  ASSESSEMENT_DELETE_ERROR,
  ASSESSEMENT_DELETE_SUCCESS,
  ASSESSEMENT_EDIT,
  ASSESSEMENT_EDIT_ERROR,
  ASSESSEMENT_EDIT_SUCCESS,
  ASSESSEMENT_GET_BY_ID,
  ASSESSEMENT_GET_BY_ID_ERROR,
  ASSESSEMENT_GET_BY_ID_SUCCESS,
  ASSESSEMENT_GET_LIST,
  ASSESSEMENT_GET_LIST_ERROR,
  ASSESSEMENT_GET_LIST_SUCCESS,
  ASSESSEMENT_ADD_NEW_REQUEST,
} from '../actions';

const initialState = {
  assessements: [],
  assessement: null,
  loading: false,
  error: null,
  addSuccess: false,
  editSuccess: false,
  deleteSuccess: false,
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case ASSESSEMENT_GET_BY_ID:
      return {
        ...state,
        loading: false,
        error: null,
        editSuccess: false,
      };
    case ASSESSEMENT_GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: true,
        assessement: payload,
      };

    case ASSESSEMENT_ADD_NEW_REQUEST:
      return {
        ...state,
        addSuccess: false,
      };
    case ASSESSEMENT_GET_LIST:
      return {
        ...state,
        error: null,
        loading: false,
      };
    case ASSESSEMENT_GET_LIST_SUCCESS:
      return {
        ...state,
        assessements: payload,
        loading: true,
      };
    case ASSESSEMENT_ADD_NEW:
      return {
        ...state,
        loading: false,
        error: null,
        addSuccess: false,
      };

    case ASSESSEMENT_ADD_NEW_SUCCESS:
      return {
        ...state,
        loading: true,
        assessement: payload,
        assessements: state.assessements.concat(payload),
        addSuccess: true,
      };

    case ASSESSEMENT_EDIT:
      return {
        ...state,
        loading: false,
        error: null,
        editSuccess: false,
      };
    case ASSESSEMENT_EDIT_SUCCESS:
      return {
        ...state,
        assessements: state.assessements.map(c => {
          return c.id === payload.id ? payload : c;
        }),
        assessement: payload,
        error: null,
        editSuccess: true,
      };
    case ASSESSEMENT_DELETE:
      return {
        ...state,
        loading: false,
        error: null,
        deleteSuccess: false,
      };
    case ASSESSEMENT_DELETE_SUCCESS:
      return {
        ...state,
        loading: true,
        assessements: state.assessements.filter(c => c.id !== payload),
        deleteSuccess: true,
      };

    case ASSESSEMENT_DELETE_ERROR:
    case ASSESSEMENT_ADD_NEW_ERROR:
    case ASSESSEMENT_EDIT_ERROR:
    case ASSESSEMENT_GET_BY_ID_ERROR:
    case ASSESSEMENT_GET_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
};
